<template>
    <div class="configurator-main-title" v-bind:id="id">
        <h1><span v-if="titleHead">{{ titleHead }}<br/></span>{{ title }}</h1>
    </div>
</template>

<script>
    export default {
        name: 'MainTitle',
        props: {
            titleHead: String,
            title: String,
            id: String
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .configurator-main-title h1 {
        margin: 0;
        font-size: 30px;
        line-height: 1.33;
        font-weight: bold;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        -webkit-hyphens: auto;
        -moz-hyphens: auto;
        -ms-hyphens: auto;
        hyphens: auto;
    }
    .configurator-main-title p {
        font-size: 24px;
        font-weight: bold;
        line-height: 1.2;
        letter-spacing: 0.38px;
        color: #ec7205;
    }

    @media (min-width: 992px) {
        .configurator-main-title h1 {
            font-size: 44px;
            line-height: 1.2;
            letter-spacing: 0.7px;
        }
    }
</style>